module.exports = __webpack_public_path__ + "static/media/office2.7cff6d66.jpg";